import React, { useState } from "react";
import { Chat } from "../../__generated__/api";
import Avatar from "../avatar/Avatar";
import IntegrationUserData from "../integration-user-data/IntegrationUserData";
import ListTickets from "../list-tickets/ListTickets";
import Resizable from "../resizable/Resizable";
import TicketPeople from "../ticket-people/TicketPeople";
import Styles from "./Chat.module.scss";

export enum Page {
    USER = "USER",
    PREVIOUS_CHATS = "PREVIOUS_CHATS",
    ALL_USERS = "ALL_USERS"
}
const PAGES = [

    {
        id: Page.USER,
        label: "Contact",
    },
    {
        id: Page.PREVIOUS_CHATS,
        label: "Previous Chats",
    },
    {
        id: Page.ALL_USERS,
        label: "People",
    },
];
export interface ChatSideBarProps {
    value: Chat
}
const SELECTED_CLASS = "bg-light p-1 px-2 rounded text-white";
export function ChatSideBar({ value }: ChatSideBarProps) {
    const [page, setPage] = useState(Page.USER);
    return (
        <Resizable
            direction="e"
            defaultSize={350}
        >
            <div className="h-100 d-flex flex-column">

                <div className="px-3 py-2 d-flex flex-column align-items-center">
                    <Avatar src={value.creator.avatarUrl as string} />
                    <h3 className="mt-2">
                        {value.creator.name}
                    </h3>
                    {value.creator.group}

                </div>
                <div
                // eslint-disable-next-line prefer-template
                    className={Styles["previous-label"]
                    + " px-1 py-1 mt-3 border-bottom mb-0 shadow-sm d-flex justify-content-start pb-2 "}
                >
                    {PAGES.map(({ id, label }) => (
                        <button
                            className={`btn btn-none  btn-sm text-gray-500 mb-0 mx-2 ${page === id ? SELECTED_CLASS : ""}`}
                            onClick={() => setPage(id)}
                            type="button"
                            key={id}
                        >
                            <small>
                                {label}
                            </small>
                        </button>
                    ))}

                </div>
                <div className={`${Styles["chat-container"]} flex-grow-1 rounded-bottom`}>
                    {page === Page.PREVIOUS_CHATS && <ListTickets id={value.creatorId} excludeId={value.id} />}
                    {page === Page.USER && <IntegrationUserData userId={value.creatorId} />}
                    {page === Page.ALL_USERS && <TicketPeople chatId={value.id} conversationSourceId={value.source?.id} />}

                </div>

            </div>
        </Resizable>
    );
}
